var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageSection',{staticClass:"default-section",attrs:{"resource":_vm.resource,"id":_vm.resource.slug,"carousel-component":_vm.carouselComponent}},[_c('PageSummary',{attrs:{"resource":_vm.resource}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }